export const colorPalette = {
  white: '#FFFFFF',
  black: '#212121',
  whiteGrey: '#F4F4F4',
  blue: '#005192',
  greyDark: '#777777',
  grey: '#9E9E9E',
  greyLight: '#00000061',
}
